import { render } from "./AccountTotal.vue?vue&type=template&id=0357f091&scoped=true"
import script from "./AccountTotal.vue?vue&type=script&lang=js"
export * from "./AccountTotal.vue?vue&type=script&lang=js"

import "./AccountTotal.vue?vue&type=style&index=0&id=0357f091&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0357f091"]])

export default __exports__